export const BIRDVIEW_CHART_PERIOD_OPTIONS = [
  { days: 7, labelKey: 'DashboardBirdview.Period7DaysOptionKey', value: '7d' },
  {
    days: 30,
    labelKey: 'DashboardBirdview.Period30DaysOptionKey',
    value: '30d',
  },
  {
    days: 90,
    labelKey: 'DashboardBirdview.Period90DaysOptionKey',
    value: '90d',
  },
]

export const BIRDVIEW_CHART_DEFAULT_PERIOD = BIRDVIEW_CHART_PERIOD_OPTIONS[1]

export const BirdviewChartMetric = {
  AvgTime: 'avg_time',
  Count: 'count',
  PerUnits: 'per_100_units',
}

export const BIRDVIEW_CHART_BUILDING_METRIC_OPTIONS = [
  {
    labelKey: 'DashboardBirdview.MetricCountKey',
    value: BirdviewChartMetric.Count,
  },
  {
    labelKey: 'DashboardBirdview.MetricPerUnitsKey',
    value: BirdviewChartMetric.PerUnits,
  },
  {
    labelKey: 'DashboardBirdview.MetricAvgTimeKey',
    value: BirdviewChartMetric.AvgTime,
  },
]

// Managers are not normalised by units.
export const BIRDVIEW_CHART_MANAGER_METRIC_OPTIONS = [
  BIRDVIEW_CHART_BUILDING_METRIC_OPTIONS[0],
  BIRDVIEW_CHART_BUILDING_METRIC_OPTIONS[2],
]

export const BirdviewAgingBasis = {
  Activity: 'activity',
  Created: 'created',
}

export const BIRDVIEW_AGING_BASIS_OPTIONS = [
  {
    labelKey: 'DashboardBirdview.AgingBasisCreatedKey',
    value: BirdviewAgingBasis.Created,
  },
  {
    labelKey: 'DashboardBirdview.AgingBasisActivityKey',
    value: BirdviewAgingBasis.Activity,
  },
]

// A card of the default size fits fewer bars than a tall one.
export const BIRDVIEW_CHART_BARS_LIMIT = 10

export const BIRDVIEW_CHART_BUILDING_BARS_DEFAULT_LIMIT = 6

export const BIRDVIEW_CHART_CATEGORY_BARS_DEFAULT_LIMIT = 5

export const BIRDVIEW_CHART_MANAGER_BARS_DEFAULT_LIMIT = 4

export const BIRDVIEW_CHART_BARS_DEFAULT_ROW_SPAN = 2
